'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dPresto$0024$0024anon$002411 from "./presto.-Presto$$anon$11.js";
import * as $j_presto$002e$002dPresto$0024$0024anon$00249 from "./presto.-Presto$$anon$9.js";
import * as $j_presto$002etypes$0024$002dCompact$002dPlan$0024 from "./presto.types$-Compact-Plan$.js";
import * as $j_presto$002etypes$0024$002dPlan$002dCode$0024 from "./presto.types$-Plan-Code$.js";
var $p;
/** @constructor */
function $c_Lpresto_Presto$$anon$8() {
  this.bcm = null;
  this.bce = null;
  this.bcf = false;
  this.bcn = null;
  this.bco = false;
  this.bcr = null;
  this.bck = null;
  this.bcl = false;
  this.bcg = null;
  this.bch = false;
  this.bci = null;
  this.bcj = false;
  this.bcp = false;
  this.bcq = false;
  this.bcm = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bcr = "CompactPlan";
}
export { $c_Lpresto_Presto$$anon$8 as $c_Lpresto_Presto$$anon$8 };
$p = $c_Lpresto_Presto$$anon$8.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_Presto$$anon$8;
/** @constructor */
function $h_Lpresto_Presto$$anon$8() {
}
export { $h_Lpresto_Presto$$anon$8 as $h_Lpresto_Presto$$anon$8 };
$h_Lpresto_Presto$$anon$8.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.J = (function() {
  return this.bcm;
});
$p.L = (function() {
  if ((!this.bcf)) {
    this.bce = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bcf = true;
  }
  return this.bce;
});
$p.O = (function() {
  if ((!this.bco)) {
    this.bcn = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bco = true;
  }
  return this.bcn;
});
$p.E = (function() {
  return this.bcr;
});
$p.t = (function() {
  if ((!this.bcl)) {
    this.bck = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("code", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("features", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bcl = true;
  }
  return this.bck;
});
$p.M = (function() {
  if ((!this.bch)) {
    this.bcg = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dPlan$002dCode$0024.$m_Lpresto_types$PlanCode$().adv(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$44(new $j_presto$002e$002dPresto$0024$0024anon$00249.$c_Lpresto_Presto$$anon$9())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bch = true;
  }
  return this.bcg;
});
$p.Q = (function() {
  if ((!this.bcj)) {
    this.bci = new $j_presto$002e$002dPresto$0024$0024anon$002411.$c_Lpresto_Presto$$anon$11();
    this.bcj = true;
  }
  return this.bci;
});
$p.w = (function() {
  if ((!this.bcq)) {
    this.bcp = false;
    this.bcq = true;
  }
  return this.bcp;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee74) => ((p) => \u03b4scrutinee74.ada(p)))($j_presto$002etypes$0024$002dCompact$002dPlan$0024.$m_Lpresto_types$CompactPlan$())));
});
var $d_Lpresto_Presto$$anon$8 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_Presto$$anon$8, "presto.Presto$$anon$8", ({
  Nj: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_Presto$$anon$8 as $d_Lpresto_Presto$$anon$8 };
//# sourceMappingURL=presto.-Presto$$anon$8.js.map
